import React, { useEffect, useRef, useState } from "react";
import * as XLSX from "xlsx";
import ListIcon from "@mui/icons-material/List";
import ReactPaginate from "react-paginate";
import { toast } from "react-toastify";
import {
  GET_STUDY_HEADERS,
  GET_STUDY_LEVEL_LOGS,
  DOWNLOAD_STUDY_LEVEL_LOGS,
} from "../../appConstants";
import moment from "moment-timezone";
import axiosInstance from "../AxiosInstance/AxiosInstance";
import DeactivateAlert from "../DeactivateAlert";
import { Tooltip } from "react-tooltip";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import BlockIcon from "@mui/icons-material/Block";
import "./Table.css";
import HideImageIcon from "@mui/icons-material/HideImage";

import FullScreenDialog from "./FullScreenDialog";
import { Oval } from "react-loader-spinner";
import LoaderComponent from "../ConfigurePages/LoaderComponent/LoaderComponent";

export default function StudyLevelTable(props) {
  const [count, setCount] = useState(1);
  const [listOfIds, setlistOfIds] = useState([]);
  const [selectedRows, setSelectedRows] = useState(new Map());
  const [isHeaderChecked, setIsHeaderChecked] = useState(false);
  const [loader, setloader] = useState(true);
  const [studyData, setStudyData] = useState([]);
  const [numberOfEntries, setNumberOfEntries] = useState(25);
  const [totalPages, setTotalPages] = useState(1);
  const [totalData, setTotalData] = useState(0);
  const [isListVisible, setListVisible] = useState(false);
  const [isDeactivateListVisible, setisDeactivateListVisible] = useState(false);
  const [fixedHeaderKey, setFixedHeaderKey] = useState([]);
  const [studyDataAllHeaders, setStudyDataAllHeaders] = useState([]);
  const [studyDataDefaultHeaders, setStudyDataDefaultHeaders] = useState([]);
  const [currentIdToDelete, setCurrentIdToDelete] = useState(-1);
  const [deleteAlert, setDeleteAlert] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [currentItem, setCurrentItem] = React.useState(null);
  const handleOpen = (items) => {
    setCurrentItem(items);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setloader(false);
        const response = await axiosInstance.post(
          `${GET_STUDY_LEVEL_LOGS}?page=${
            props.searchflag || props.flagforfilterby ? 1 : count
          }&size=${numberOfEntries}`,
          props.searchInput,
          { headers: { Authorization: `Bearer ${localStorage.access_token}` } }
        );
        setStudyData(response?.data?.items || []);
        setTotalPages(response.data.pages || 1);
        setTotalData(response.data.total || 0);
        setloader(true);
      } catch (error) {
        toast.error(`Error: ${error.message}`, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        setloader(true);
      }
    };

    fetchData();
  }, [
    props.searchInput,
    count,
    deleteAlert,
    numberOfEntries,
    props.searchflag,
  ]);

  useEffect(() => {
    if (props.flagforfilterby) {
      setCount(1);
    }
  }, [props.flagforfilterby]);

  useEffect(() => {
    if (props.searchflag) {
      setCount(1);
    }
  }, [props.searchflag, props.searchInput]);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.get(GET_STUDY_HEADERS, {
          headers: { Authorization: `Bearer ${localStorage.access_token}` },
        });

        let defaultHeaders = response?.data?.default_headers || [];
        // defaultHeaders.push({
        //   display_header: "On-Image Anon",
        //   response_header: "On-Image Anon",
        // });
        let allHeaders = response?.data?.all_headers || [];
        // allHeaders.push({
        //   display_header: "On-Image Anon",
        //   response_header: "On-Image Anon",
        // });

        let formattedDefaultHeaders = defaultHeaders.map((item, index) => ({
          key: item.response_header,
          value: item.display_header,
          originalIndex: index,
        }));

        let formattedAllHeaders = allHeaders.map((item) => ({
          key: item.response_header,
          value: item.display_header,
        }));

        // Store the initial defaultHeaders with their original indexes in localStorage
        localStorage.setItem(
          "originalHeaders",
          JSON.stringify(formattedDefaultHeaders)
        );

        try {
          const localdefaultheader = localStorage.getItem("defaultHeaders");
          if (localdefaultheader) {
            setStudyDataDefaultHeaders(JSON.parse(localdefaultheader));
          } else {
            setStudyDataDefaultHeaders(formattedDefaultHeaders);
          }
          setStudyDataAllHeaders(formattedAllHeaders);
        } catch (err) {
          console.log("Some error occured", err);
        }
        try {
          let localdefaultheaderKey = localStorage.getItem("fixedHeaderKey");
          if (localdefaultheaderKey) {
            setFixedHeaderKey(JSON.parse(localdefaultheaderKey));
          } else {
            const fixedHeaderKeys = defaultHeaders.map(
              (header) => header.response_header
            );
            setFixedHeaderKey(fixedHeaderKeys);
          }
        } catch (error) {
          console.log("Some error occured", error);
        }
      } catch (error) {
        toast.error(`Error: ${error.message}`, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    };

    fetchData();
  }, []);

  const handleHeaderCheckboxChange = () => {
    const newValue = !isHeaderChecked;
    setIsHeaderChecked(newValue);

    // Create new map with updated values for ALL studies (active and inactive)
    const newSelectedRows = new Map();
    studyData.forEach((item) => {
      newSelectedRows.set(item.id, newValue);
    });

    setSelectedRows(newSelectedRows);

    // Use the newly updated map to get checkedIds
    const checkedIds = [];
    newSelectedRows.forEach((isChecked, id) => {
      if (isChecked) {
        checkedIds.push(id);
      }
    });

    setlistOfIds(checkedIds);
  };

  // Handle individual row checkbox change
  const handleRowCheckboxChange = (id) => {
    const newSelectedRows = new Map(selectedRows);
    const currentState = newSelectedRows.get(id);
    newSelectedRows.set(id, !currentState);

    setSelectedRows(newSelectedRows);

    // Use the newly updated map to get checkedIds
    const checkedIds = [];
    newSelectedRows.forEach((isChecked, id) => {
      if (isChecked) {
        checkedIds.push(id);
      }
    });

    setlistOfIds(checkedIds);

    // Check if all items are selected
    const allChecked = studyData.every((item) => newSelectedRows.get(item.id));
    setIsHeaderChecked(allChecked);
  };

  // Extract IDs of checked rows

  const handleviewstudy = (items) => {
    let username = localStorage.getItem("username");

    let filterobj = {};

    filterobj.platform_url = items?.platform_url;

    filterobj.study_id = items?.anonymized_study_instance_uid;
    if (items?.push_back && items.push_back == 2) {
      window.open(
        `${filterobj.platform_url}/api/v2/datasets/router_viewer_url?&study_id=${filterobj.study_id}&token=eyJhbGciTEFtthfZsfQiFPF_ylYZribciedUNLUoajh2&application_id=""&username=${username}&emailid=''`
      );
    } else {
      window.open(
        `${filterobj.platform_url}/api/v2/datasets/router_viewer_url?&study_id=${filterobj.study_id}&token=eyJhbGciTEFtthfZsfQiFPF_ylYZribciedUNLUoajh2&application_id=""&username=${username}&emailid=''&original=1`
      );
    }
  };

  const handleViewStudyImageRedaction = (items) => {
    let username = localStorage.getItem("username");

    let filterobj = {};
    filterobj.study_id = items?.study_instance_uid;
    window.open(
      `/viewer/index.html?sid=${filterobj.study_id}&pid=-1&ptype=1&ds=4917&is_anno=0`
    );
  };

  const handleDelete = () => {
    setDeleteAlert(true);
  };

  const toggleList = () => {
    setListVisible(!isListVisible);
  };
  const DeactivateToggle = () => {
    handleDelete();
    setisDeactivateListVisible(!isDeactivateListVisible);
  };

  const handlePageChange = (page) => {
    props.setflagforfilterby(false);
    setIsHeaderChecked(false);
    setlistOfIds([]);
    props.setsearchflag(false);
    if (page >= 0 && page <= totalPages) {
      setCount(page + 1);
    }
  };
  const handleCheckboxChange = (e, item) => {
    e.stopPropagation();

    setStudyDataDefaultHeaders((prevHeaders) => {
      // Find the index of the item
      const index = prevHeaders.findIndex((header) => header.key === item.key);

      if (index !== -1) {
        // Save the index and remove the item
        prevHeaders = [
          ...prevHeaders.slice(0, index),
          ...prevHeaders.slice(index + 1),
        ];
        // Store the index in the item itself (or use another mechanism to remember the index)
        item._index = index;
      } else {
        const originalHeaders = JSON.parse(
          localStorage.getItem("originalHeaders")
        );
        const originalHeader = originalHeaders.find(
          (header) => header.key === item.key
        );

        const originalIndex = originalHeader
          ? originalHeader.originalIndex
          : prevHeaders.length;
        prevHeaders = [
          ...prevHeaders.slice(0, originalIndex),
          item,
          ...prevHeaders.slice(originalIndex),
        ];
      }
      localStorage.setItem("defaultHeaders", JSON.stringify(prevHeaders));
      return prevHeaders;
    });

    setFixedHeaderKey((prevKeys) => {
      let newKeys;

      // If the item key exists in the previous keys, remove it
      if (prevKeys.includes(item.key)) {
        newKeys = prevKeys.filter((key) => key !== item.key);
      } else {
        // Add the key back at its original position
        const originalHeaders = JSON.parse(
          localStorage.getItem("originalHeaders")
        );
        const originalHeader = originalHeaders.find(
          (header) => header.key === item.key
        );

        const originalIndex = originalHeader
          ? originalHeader.originalIndex
          : prevKeys.length;
        newKeys = [
          ...prevKeys.slice(0, originalIndex),
          item.key,
          ...prevKeys.slice(originalIndex),
        ];
      }
      localStorage.setItem("fixedHeaderKey", JSON.stringify(newKeys));
      return newKeys;
    });
  };

  const handleOption = (e) => {
    if (totalData >= e.target.value) {
      setNumberOfEntries(e.target.value);
    } else {
      setNumberOfEntries(totalData);
    }
  };

  const containerRef = useRef(null);
  const DeactivateRef = useRef(null);

  const handleClickOutside = (event) => {
    if (containerRef.current && !containerRef.current.contains(event.target)) {
      setListVisible(false);
    }
  };
  // const dateConversionCSV = (timestampStr) => {

  //   return formattedDate;
  // };
  const handlestudydownload = () => {
    const downloadExcel = (data) => {
      const datetimevalue = [
        "Receive Time",
        "Last Update",
        "First Slice Receive",
        "Last Slice Receive",
        "First Slice Upload",
        "Last Slice Upload",
        "Results Pushed To PACS",
        "HL7 Sent Time",
      ];

      const workbook = XLSX.utils.book_new();

      Object.keys(data).forEach((testAlgo) => {
        const studyData = data[testAlgo];
        const keys = Object.keys(studyData[0]);

        let aiResults = studyData[0]?.ai_headers;

        const selectedHeaderNames = studyDataDefaultHeaders?.map(
          (headerObj) => {
            if (headerObj.value === "TAT") {
              return "Total Processing Time"; // Replace "AnotherName" with the desired name
            }
            return headerObj.value;
          }
        );
        const filteredKeys = keys.filter((key) =>
          selectedHeaderNames?.includes(key)
        );
        if (aiResults) {
          filteredKeys.push(...aiResults);
        }

        const rows = [
          filteredKeys,
          ...studyData.map((row) =>
            filteredKeys.map((key) => {
              let value = row[key];
              if (datetimevalue.includes(key)) {
                value = dateConversion(value);
              }
              return value;
            })
          ),
        ];

        const worksheet = XLSX.utils.aoa_to_sheet(rows);
        XLSX.utils.book_append_sheet(workbook, worksheet, testAlgo);
      });

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const blob = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "data.xlsx";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setLoading(false);
    };

    const DownloadData = async () => {
      setLoading(true);

      try {
        // If there are selected studies, include their IDs in the request
        // Otherwise, download all studies based on search filters
        const requestBody = {
          ...props.searchInput,
          ...(listOfIds && listOfIds.length > 0 && { study_ids: listOfIds }),
        };

        const response = await axiosInstance.post(
          `${DOWNLOAD_STUDY_LEVEL_LOGS}`,
          requestBody,

          { headers: { Authorization: `Bearer ${localStorage.access_token}` } }
        );
        // console.log(response.data);
        downloadExcel(response?.data);
      } catch (error) {
        toast.error(`Error: ${error.message}`, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        setLoading(false);
      }
    };

    DownloadData();
  };
  const dateConversion = (timestampStr) => {
    if (!timestampStr.trim()) {
      return timestampStr;
    }
    return timestampStr;
  };
  const styles = {
    listStyles: {
      left: "86vw",
      position: "absolute",
      backgroundColor: "#182423",
      color: "white",
      zIndex: 1,
      border: "1px solid #ccc",
      borderRadius: "5px",
      padding: "10px",
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
      width: "fit-content",
      minWidth: "200px",
    },
  };
  const styles2 = {
    listStyles: {
      position: "absolute",
      marginLeft: "94px",
      marginTop: "-50px",
      backgroundColor: "#182423",
      color: "white",
      zIndex: 1,
      border: "1px solid #ccc",
      borderRadius: "5px",
      padding: "10px",
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
      width: "fit-content",
      minWidth: "99px",
    },
  };

  return (
    <>
      <div className="d-flex content-center">
        <div>
          {!loading ? (
            <i
              className="icon_box fa fa-download"
              style={{ color: "#f9d7a1", opacity: "1", fontSize: "14px" }}
              data-tooltip-content="Export Data"
              data-tooltip-id="download"
              onClick={() => {
                studyData?.length > 0 ? handlestudydownload() : <></>;
              }}
            />
          ) : (
            <>
              {" "}
              <>
                {" "}
                <Oval
                  visible={true}
                  height="30"
                  width="30"
                  color="#4fa94d"
                  ariaLabel="oval-loading"
                  wrapperStyle={{}}
                  wrapperClass=""
                />
              </>
            </>
          )}
        </div>
        <Tooltip
          id="download"
          place="right"
          type="dark"
          effect="solid"
          multiline={true}
        />
        <div
          style={{
            pointerEvents: listOfIds && listOfIds.length === 0 ? "none" : "",
            opacity: listOfIds && listOfIds.length === 0 ? 0.5 : 1,
          }}
        >
          <i
            className=" icon_box fa fa-stop-circle"
            style={{ color: "#f9d7a1", opacity: "1", fontSize: "14px" }}
            data-tooltip-content="Deactivate Studies"
            data-tooltip-id="Deactivate Studies"
            onClick={DeactivateToggle}
          ></i>
        </div>
        <Tooltip
          id="Deactivate Studies"
          place="right"
          type="dark"
          effect="solid"
          multiline={true}
        />
        <div>
          <ListIcon
            style={{ marginLeft: "84vw" }}
            onClick={toggleList}
            ref={containerRef}
          />
        </div>
      </div>

      {isListVisible && (
        <div
          onClick={(e) => e.stopPropagation()}
          className="your-list-styles"
          style={styles.listStyles}
        >
          <div>
            {studyDataAllHeaders.map((item) => {
              const isChecked = studyDataDefaultHeaders.some(
                (data) => data.value === item.value
              );

              return (
                <div key={item.key}>
                  <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={(e) => handleCheckboxChange(e, item)}
                  />{" "}
                  <span> {item.value}</span>
                </div>
              );
            })}
          </div>
        </div>
      )}
      {isDeactivateListVisible && (
        <div onClick={(e) => e.stopPropagation()}></div>
      )}

      {loader ? (
        <div
          className="d-flex flex-column"
          style={{ width: "91vw", overflowX: "auto" }}
        >
          <div>
            <div className="table-main-inside">
              <table className="styled-table-home">
                <thead>
                  <tr style={{ fontSize: "14px" }}>
                    <th style={{ width: "8%" }}>
                      <label className="main_checkbox">
                        <input
                          type="checkbox"
                          checked={isHeaderChecked}
                          onChange={handleHeaderCheckboxChange}
                        />
                        <div className="carpl_checkbox" />
                      </label>
                    </th>
                    <th style={{ width: "8%" }}>Status</th>

                    {studyDataDefaultHeaders.map((item, index) => (
                      <th
                        key={index}
                        style={{
                          width: `calc((90vw - 16%) / ${studyDataDefaultHeaders.length})`,
                        }}
                      >
                        {item.value}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {studyData.length > 0 ? (
                    studyData.map((items, index) => (
                      <tr
                        key={index}
                        className="styled-table"
                        style={{ fontSize: "14px" }}
                      >
                       
                        <td>
                          {items.active !== "True" && items.status && items.status_desc.toLowerCase().includes("deactivated by user") ? (
                            <i 
                              className="fa fa-window-close-o deactivated-icon" 
                              title="Deactivated by user"
                            />
                          ) : (
                            <label className="main_checkbox">
                              <input
                                type="checkbox"
                                checked={
                                  (selectedRows &&
                                    selectedRows.get(items.id)) ||
                                  false
                                }
                                onChange={() =>
                                  handleRowCheckboxChange(items.id)
                                }
                                disabled={items.active !== "True"}
                              />
                              <div className={`carpl_checkbox ${items.active !== "True" ? "inactive" : ""}`} />
                            </label>
                          )}

                          {deleteAlert && (
                            <DeactivateAlert
                              type={"studylevellogs"}
                              id={listOfIds}
                              deleteAlert={deleteAlert}
                              setDeleteAlert={setDeleteAlert}
                              handlePage={handlePageChange}
                              count={count}
                              data={studyData}
                              setlistOfIds={setlistOfIds}
                            />
                          )}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {items.active === "True" ? (
                            <CheckCircleIcon 
                              className="status-icon-active"
                              titleAccess="Active"
                            />
                          ) : (
                            <BlockIcon 
                              className="status-icon-inactive"
                              titleAccess="Inactive"
                            />
                          )}
                        </td>
                        {fixedHeaderKey.map((key) => (
                          <td
                            key={key}
                            className="word-break"
                            style={{
                              color:
                                items.active !== "True" ? "#bebebe" : undefined,
                            }}
                          >
                            {[
                              "created_on",
                              "last_updated_at",
                              "first_slice_receive",
                              "last_slice_receive",
                              "first_slice_upload",
                              "last_slice_upload",
                              "results_pushed_to_pacs",
                              "hl7_sent_time",
                            ].includes(key) ? (
                              dateConversion(items[key])
                            ) : key === "view_study" ? (
                              items.active === "True" &&
                              (items["status"].includes(
                                "Inference Status: Processed"
                              ) ||
                                items["status"].includes(
                                  "Successfully pushed results to PACS"
                                )) ? (
                                <button
                                  className="btn mr-4 shadow btn-dataset"
                                  style={{
                                    color: "black",
                                    backgroundColor: "#0FC4A0",
                                    cursor: "pointer",
                                    fontWeight: "500",
                                    fontFamily: "Montserrat",
                                    fontSize: "14px",
                                  }}
                                  onClick={() => {
                                    handleviewstudy(items);
                                  }}
                                >
                                  VIEW
                                </button>
                              ) : (
                                <button
                                  type="button"
                                  className="btn mr-4 shadow btn-dataset"
                                  style={{
                                    color: "rgb(0 0 0 / 73%)",
                                    backgroundColor: "rgb(128 128 128 / 50%)",
                                    fontWeight: "500",
                                    cursor: "default",
                                    fontFamily: "Montserrat",
                                    fontSize: "14px",
                                  }}
                                >
                                  VIEW
                                </button>
                              )
                            ) : (
                              // : key == "On-Image Anon" ? (
                              //   <HideImageIcon
                              //     sx={{
                              //       cursor: "pointer",
                              //       color: "#0cc4a0 !important",
                              //     }}
                              //     onClick={() => {
                              //       handleViewStudyImageRedaction(items);
                              //     }}
                              //   />
                              // )

                              items[key]
                            )}
                          </td>
                        ))}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={studyDataDefaultHeaders.length + 2}
                        className="text-center font-weight-bold"
                      >
                        No Records Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ) : (
        <div
          className="d-flex align-items-center justify-content-between"
          style={{ margin: "10vw 48vw" }}
        >
          <div>
            <LoaderComponent />
          </div>
        </div>
      )}
      <div>
        {" "}
        {studyData.length > 0 && (
          <div className="d-flex justify-content-between pb-5 mt-2">
            <div style={{ color: "white", fontSize: "14px" }}>
              <div>
                <span>Show </span>
                <select
                  className="entries-select"
                  onChange={(e) => handleOption(e)}
                  value={Number(numberOfEntries)}
                >
                  {[10, 15, 20, 25, 50, 75, 100].map((pageSize) => (
                    <option
                      key={pageSize}
                      value={pageSize}
                      style={{ color: "#82024" }}
                    >
                      {pageSize}
                    </option>
                  ))}
                </select>
                <span>Entries </span>
              </div>
              {`Showing ${
                numberOfEntries * count - (numberOfEntries - 1)
              } to ${Math.min(
                numberOfEntries * count,
                totalData
              )} of ${totalData} Entries`}
            </div>
            <div>
              <ReactPaginate
                previousLabel="<"
                nextLabel=">"
                breakLabel="..."
                breakClassName="break-me"
                pageCount={totalPages}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                forcePage={count && count - 1}
                onPageChange={(e) => handlePageChange(e.selected)}
                containerClassName="pagination"
                subContainerClassName="pages pagination"
                activeClassName="active"
                previousLinkClassName="pagination-link"
                nextLinkClassName="pagination-link"
                breakLinkClassName="pagination-link"
                pageLinkClassName="pagination-link"
              />
            </div>
          </div>
        )}
        <FullScreenDialog
          open={open}
          handleClose={handleClose}
          currentItem={currentItem}
        />
      </div>
    </>
  );
}
